import {
  useTranslate,
  IResourceComponentsProps,
  HttpError,
  useExport,
} from "@refinedev/core";

import { List, useTable } from "@refinedev/antd";
import { Button, Table } from "antd";

import { ITip } from "interfaces";

export const TipsList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable<ITip, HttpError>({
    resource: "tips",
  });

  const t = useTranslate();

  const { triggerExport, isLoading: isExportLoading } = useExport<ITip>({
    resource: "tips",
    mapData: (item) => item,
  });

  return (
    <List>
      <div style={{ display: "flex", gap: 4 }}>
        <Button
          type="primary"
          disabled={isExportLoading}
          onClick={triggerExport}
        >
          {isExportLoading ? "Exporting..." : "Export as CSV"}
        </Button>
      </div>
      <Table {...tableProps}>
        <Table.Column<ITip>
          key="serviceType"
          dataIndex={"serviceType"}
          title={t("Service")}
        />
        <Table.Column<ITip>
          key="orderId"
          dataIndex={"orderId"}
          title={t("Order ID")}
        />
        <Table.Column<ITip>
          key="email"
          dataIndex={"email"}
          title={t("Email")}
        />
        <Table.Column<ITip>
          key="date"
          dataIndex={"date"}
          title={t("Date")}
          render={(value: { seconds: number }) => {
            return new Date(value.seconds * 1000).toLocaleDateString()
          }}
        />
        <Table.Column<ITip>
          key="amountGbp"
          dataIndex={"amountGbp"}
          title={t("Amount")}
          render={(value: number) =>
            new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value)
          }
        />
      </Table>
    </List>
  );
};

